export default __webpack_public_path__ + "locales/el-GR/DeleteProfileEverDialog.json?hash=d70ffee7af3fff6cc5f995569a309373";